import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { login } from '@/api/auth';
import { decodeJwtPayload, useAuthStore } from '@/store/authStore';

export function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const setAuth = useAuthStore((s) => s.setAuth);

  const mutation = useMutation({
    mutationFn: () => login(email, password),
    onSuccess: (data) => {
      const user = decodeJwtPayload(data.access_token);
      if (!user) {
        throw new Error('JWT inválido recebido do backend');
      }
      setAuth(data.access_token, user);
    },
  });

  return (
    <div className="min-h-screen flex items-center justify-center p-8">
      <div className="w-full max-w-sm space-y-8">
        <header className="text-center space-y-2">
          <div className="inline-block w-12 h-12 rounded-lg bg-surf-accent flex items-center justify-center mx-auto">
            <span className="text-white font-bold text-lg">S</span>
          </div>
          <h1 className="text-xl font-semibold">Surf Monitor</h1>
          <p className="text-sm text-surf-text-secondary">
            Entre com suas credenciais corporativas
          </p>
        </header>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            mutation.mutate();
          }}
          className="space-y-4"
        >
          <Field
            label="Email"
            type="email"
            value={email}
            onChange={setEmail}
            required
            autoFocus
          />
          <Field
            label="Senha"
            type="password"
            value={password}
            onChange={setPassword}
            required
          />

          {mutation.isError && (
            <div className="text-2xs text-surf-accent-red font-mono p-2 rounded bg-surf-accent-red/5 border border-surf-accent-red/20">
              {mutation.error.message}
            </div>
          )}

          <button
            type="submit"
            disabled={mutation.isPending || !email || !password}
            className="w-full py-2.5 rounded bg-surf-accent text-white text-sm font-medium hover:bg-surf-accent/90 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            {mutation.isPending ? 'Entrando…' : 'Entrar'}
          </button>
        </form>

        <p className="text-2xs text-center text-surf-text-tertiary font-mono">
          monitor.stage.surf.com.br
        </p>
      </div>
    </div>
  );
}

function Field({
  label,
  type,
  value,
  onChange,
  required,
  autoFocus,
}: {
  label: string;
  type: string;
  value: string;
  onChange: (v: string) => void;
  required?: boolean;
  autoFocus?: boolean;
}) {
  return (
    <label className="block space-y-1">
      <span className="text-2xs uppercase tracking-wider text-surf-text-tertiary font-mono">
        {label}
      </span>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        autoFocus={autoFocus}
        className="w-full px-3 py-2 rounded bg-surf-bg-1 border border-surf-border text-sm text-surf-text-primary focus:outline-none focus:border-surf-accent transition-colors"
      />
    </label>
  );
}
